import React from 'react';
import GoogleMapReact from 'google-map-react';
import { connect } from 'react-redux';
import { compose, mergeDeepRight, reduceWhile } from 'ramda';
import actions from './../../../store/actions';
import { List, Map } from 'immutable';
import classnames from 'classnames/bind';

import { checkAvailSegments,getUniqueRef } from '../../../utils';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import styleFile from './GoogleMap.js';
import styleMapTooltip from './GoogleMapTooltip.js';
import RichText from '@synergycms_core/components/generic/RichText';
import Stars from '../../functional/Stars';
import ContentProvider from '@synergycms_core/components/providers/translateProvider';
import Price from '@synergycms_core/components/generic/Price';
import { Image, Button } from '@synergycms_core/components/generic/';
import { langCodeCorrector } from '@synergycms_core/utils/api';
import TooltipWrapper from '@synergycms_core/components/generic/TooltipWrapper';
import { showPopover } from '@synergycms_core/components/providers/popoverProvider.jsx';
import { AD_BOARD, AD_BOARD_BUFFET, PROPERTY_MANAGEMENT_GROUP } from '../../../config/constants';
import { formatPrice } from '../../../utils/priceFormatter.js';

const reduceWhileResolved = config => {
  const itemsResolveds = reduceWhile(
    (itemsResolveds, hotelId) => {
      return config.avail.get(hotelId);
    },
    (itemsResolveds, hotelId) => {
      itemsResolveds = itemsResolveds.set(hotelId, config.avail.get(hotelId));
      return itemsResolveds;
    },
    new Map(),
    config.hotelsIds
  );
  return config.hotelsIds.size > 0 && config.hotelsIds.size === itemsResolveds.size ? itemsResolveds : undefined;
};

class GoogleMap extends React.Component {
  static displayName = 'GoogleMap';
  static defaultProps = {
    zoom: 11
  };
  constructor(props) {
    super(props);

    const { city, country } = props.config;
    let zoom;

    if (city.size > 0) {
      zoom = this.props.zoom;
    } else {
      zoom = parseInt(country.get('zoom', 6), 10);
    }

    let safeZoom = Number.isFinite(zoom) ? zoom : 6;

    this.state = {
      showMapToolTip: false,
      zoom: safeZoom,
      click: 0
    };
    this.onNextClick = this.props.config.onNextClick.bind(this);
    this.hotelTooltipClosers = {};
    this.closeTooltipByFamily = this.props.config.closeByFamily;
  }

  createMapOptions = maps => {
    return {
      zoomControlOptions: {
        position: maps.ControlPosition.LEFT_BOTTOM
      },
      zoomControl: this.props.theme.deviceType === 'DESK',
      mapTypeControl: true,
      gestureHandling: 'greedy',
      clickableIcons: false,
      restriction: {
        latLngBounds: { north: 85, south: -85, west: -180, east: 180 }
      },
    };
  };

  getMapHotelInfoPrice = hotelId => {
    const { hotels, avail, hotelsIds, availStringParams } = this.props.config,
      queryParams = hotels.getIn([hotelId, 'params', availStringParams]),
      availData = avail.getIn([hotelId, queryParams, 'raw_response']);

    let bestPrice = 0;
    let bestPriceTax = 0;
    let totalAddedPrice = 0;
    let parsedHotelsIds = [];
    if(hotelsIds.size) parsedHotelsIds = hotelsIds.map(id => parseInt(id));

    if (parsedHotelsIds.includes(hotelId) && checkAvailSegments(availData)) {
      const showTaxes = hotels.getIn([hotelId, 'show_taxes']);
      const summaryPriceBreakdown = hotels.getIn([hotelId, 'summary_price_breakdown'], false);
      const managementGroupId = hotels.getIn([hotelId, 'management_group_id']);
      const bestRoom = availData.getIn([0, 'rooms', 0], Map());
      const bestBoards = bestRoom.getIn(['boards']);
      const stayLength = bestRoom.get('days').size;
      const hasFreeBreakfast = bestRoom.get('free_breakfast', false);
      let bestBoard = !hasFreeBreakfast
        ? bestBoards.first()
        : bestBoards.get(
          bestBoards.findIndex(
            b => b.get('board_code') === AD_BOARD || b.getIn([getUniqueRef(b), 'board_code']) === AD_BOARD_BUFFET
          ),
          Map()
        );

      if (!bestBoard.size) {
        bestBoard = bestBoards.get(0, Map());
      }

      bestPrice = bestBoard.get(showTaxes ? 'price_tax' : 'price') / stayLength;
      bestPriceTax = bestBoard.get('price_tax');

      totalAddedPrice = bestPriceTax;
      if(managementGroupId === PROPERTY_MANAGEMENT_GROUP && summaryPriceBreakdown){
        totalAddedPrice += bestBoard.get('local_taxes', List()).reduce((taxAcc, tax) =>  {
          return taxAcc + tax.get('tax_amount', 0);
        }, 0)
      }
    }

    return {
      stars: hotels.getIn([hotelId, 'stars']),
      name: hotels.getIn([hotelId, 'name']),
      managementGroupId: hotels.getIn([hotelId, 'management_group_id']),
      summaryPriceBreakdown: hotels.getIn([hotelId, 'summary_price_breakdown'], false),
      categoryType: hotels.getIn([hotelId, 'category_type'], 'default'),
      currencyCode: hotels.getIn([hotelId, 'currency','code']),
      price: bestPrice,
      priceTax: bestPriceTax,
      totalAddedPrice: totalAddedPrice,
      default_photo: hotels.getIn([hotelId, 'default_photo'])
    };
  };

  setCenter = (lat, lang) => e => {
    this.setState(state =>
      mergeDeepRight(state, {
        center: { lat: lat, lng: lang },
        click: this.state.click + 1
      })
    );
  };

  onBoundsChange = () => {
    this.closeTooltipByFamily();
  };

  onMove = () => { };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.click !== this.state.click) {
      window.google &&
        this.mapRef &&
        this.mapRef.map_ &&
        this.mapRef.map_.panTo &&
        this.mapRef.map_.panTo(new window.google.maps.LatLng(this.state.center.lat, this.state.center.lng));
    }
  }

  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const {
      hotelsFilter,
      hotels,
      hotelsIds,
      langCode,
      googleApiKey,
      availStringParams,
      currencies,
      currentCurrencyCode,
      customerCountry
    } = config;

    const hotelsAvail = reduceWhileResolved(config);
    const hotelsChoordinates =
      hotelsAvail &&
      hotelsIds.reduce((h, hotelId) => {
        const hotel = config.hotels.get(hotelId),
          queryParams = hotels.getIn([hotelId, 'params', availStringParams]);
        if (
          hotel &&
          hotel.get('latitude') &&
          hotel.get('longitude') &&
          hotelsAvail.getIn([hotelId, queryParams, 'raw_response', 0, 'success']) &&
          !hotelsAvail.getIn([hotelId, queryParams, 'is_alter_search']) && 
          (!hotelsFilter.size || hotelsFilter.has(hotelId))
        ) {
          h = h.set(hotelId, {
            latitude: parseFloat(hotel.get('latitude')),
            longitude: parseFloat(hotel.get('longitude')),
            hotelId: hotelId,
            code: hotel.get('code'),
            name: hotel.get('name'),
            brand: hotel.get('brand'),
          });
        }
        return h;
      }, new Map());

    const { city, country } = this.props.config;
    let center;

    if (city.size > 0) {
      center = {
        lat: parseFloat(city.get('latitude', 0)),
        lng: parseFloat(city.get('longitude', 0))
      };
    } else {
      center = {
        lat: parseFloat(country.get('latitude', 0)),
        lng: parseFloat(country.get('longitude', 0))
      };
    }

    const cx = classnames.bind(classes);
    const hotelsMap = hotelsChoordinates.size > 0 && hotelsChoordinates.toJS();

    return (
      Object.keys(hotelsMap).length > 0 && (
        // Important! Always set the container height explicitly
        <div className={theme.computedInnerStyle}>
          <GoogleMapReact
            ref={ref => {
              this.mapRef = ref;
            }}
            key={this.state.key}
            onChange={this.onMoveMap}
            onZoomAnimationStart={this.onBoundsChange}
            onClick={this.onBoundsChange}
            onDrag={this.onBoundsChange}
            options={this.createMapOptions}
            bootstrapURLKeys={{
              key: googleApiKey,
              language: langCode,
              region: langCode
            }}
            defaultCenter={{ ...center }}
            defaultZoom={this.state.zoom}>
            {Object.keys(hotelsMap).map(h => {
              h = parseInt(h,10);
              const hotelMapInfo = this.getMapHotelInfoPrice(h);
              const hotelCode = hotelsMap[h].code;
              const hotelBrand = hotelsMap[h].brand;
              return (
                <ContentProvider
                  value={{ theme: (window.frontLoader && window.frontLoader['cms-avail']?.config?.theme) || window.synergyCmsAvailTheme }}
                  key={'themeProvGMaps' + hotelsMap[h].hotelId}
                  lat={hotelsMap[h].latitude}
                  lng={hotelsMap[h].longitude}>
                  <TooltipWrapper
                    onlyCloseByButton={true}
                    removeTooltipTimeout={100}
                    popover={(toogleTooltip, forceCloseTooltip) => {
                      this.hotelTooltipClosers[h] = { forceCloseTooltip };
                      return <ModalGoogle 
                      onNextClick={this.onNextClick(h, hotelCode)} 
                      hotelMapInfo={hotelMapInfo}
                      currencyInfo={{
                        currencies,
                        currentCurrencyCode,
                        customerCountry
                      }}
                      hotelBrand={hotelBrand} />;
                    }}
                    typeTooltip={'googleTooltip-' + h}
                    pointerStyle={classes.tooltipPointer}
                    posX={'middle'}
                    posY={'bottom'}>
                    <div className={cx(classes.gmapMarkerIcon, {
                      selected: +config.hover === +hotelsMap[h].hotelId
                    })}>
                      <Image
                        alt={hotelsMap[h].name}
                        svg={'gmapmarker'}
                        onClick={() => {
                          this.setCenter(hotelsMap[h].latitude, hotelsMap[h].longitude)();
                          this.closeTooltipByFamily();
                        }}
                      />
                    </div>
                  </TooltipWrapper>
                </ContentProvider>
              );
            })}
          </GoogleMapReact>
        </div>
      )
    );
  }
}

const ModalGoogle = compose(withThemeJSS({ styleFile: styleMapTooltip, displayName: 'ModalGoogle', link: true }))(props => {
  const { classes } = props.theme.styles;
  const resizableImages = props.theme.resizableImages ? '?width=400&height=1' : '';
  return (
    <div className={classes.mapHotelPopover}>
      <div className={classes.mapTooltip}>
        {props.theme.width > 800 && (
          <div className={classes.tooltipImage}>

            {props.hotelBrand && <Image innerStyle={classes.hotelBrandTooltip} svg={props.hotelBrand + 'BrandMap'} />}
            <Image
              innerStyle={'backgroundImageBase'}
              alt={props.hotelMapInfo.name}
              backgroundImage={
                process.env.NODE_ENV === 'development'
                  ? 'https://edge.media.datahc.com/HI378221428.jpg' + resizableImages
                  : props.hotelMapInfo.default_photo + resizableImages
              }
            />
          </div>
        )}
        <Stars
          innerStyle={classes.tooltipHotelStars}
          style={['block']}
          stars={props.hotelMapInfo.stars}
          categoryType={props.hotelMapInfo.categoryType}
        />
        <div className={classes.tooltipHotelName}>{props.hotelMapInfo.name}</div>
        <div className={classes.infoHotelCost}>
          <div className={classes.infoCostFrom}>
            <RichText text={'_%desde%_'} ucFirst={true} translate={true} />
          </div>
          <div className={classes.infoPrice}>
            <Price amount={props.hotelMapInfo.price} hotelCurrencyCode={props.hotelMapInfo.currencyCode}/>
          </div>
          <div className={classes.infoCostType}>
            <RichText text={'_%habitación%_'} translate={true} innerStyle={['capitalize']} />
            {' / '}
            <RichText text={'_%noche%_'} translate={true} innerStyle={['capitalize']} />
          </div>
        </div>
        <div style={{ zIndex: 99999999999 }} className={classes.footerMapTooltip}>
          <Button
            innerStyle={['toggleMainButton']}
            onClick={props.onNextClick}
            richText={{
              text: '_%ver habitación%_',
              plural: true,
              translate: true,
              ucFirst: true,
              innerStyle: ['toggleMainButton']
            }}
            ariaLabel={'_%ver habitación%_'}
            translate={true}
          />
        </div>
        {props.hotelMapInfo.managementGroupId === PROPERTY_MANAGEMENT_GROUP && props.hotelMapInfo.summaryPriceBreakdown && (
        <div className={[classes.alignRight, classes.mapTaxes].join(' ')}>
          <RichText 
            text={'_%{totalPrice} total con tasas y fees%_'}
            translate={true}
            withVars={{
              totalPrice: formatPrice(props.hotelMapInfo.totalAddedPrice, {
                ...props.currencyInfo,
                hotelCurrencyCode: props.hotelMapInfo.currencyCode
              })
            }} />
        </div> 
      )}
      </div>
    </div>
  );
});

const mapDispatchToProps = dispatch => {
  return {
    onNextClick: (hotelId, hotelCode) => e => {
      e.stopPropagation();
      e.preventDefault();
      dispatch(actions.app.goToMonoHotelAsync(hotelId));
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  const params = store.getIn(['customer', 'params', 'params'], undefined);

  const country =
    params &&
    params.get('country_id') &&
    store.getIn(['hotels', 'hotels_info', 'countries']).find(country => {
      return country.get('id') === parseInt(params.get('country_id'), 10);
    });

  const city =
    params &&
    params.get('city_id') &&
    store.getIn(['hotels', 'hotels_info', 'cities']).find(city => {
      return city.get('id') === parseInt(params.get('city_id'), 10);
    });

  const langCode = store.getIn(['customer', 'lang_info', 'code'], 'en');
  
  return {
    availStringParams:  store.getIn(["availQuery", "multi", "base_query_params"]),
    hotelsIds: store.getIn(['customer', 'current_hotels']),
    cities: store.getIn(['hotels', 'hotels_info', 'cities']),
    hotels: store.get('hotels'),
    avail: store.get('avail'),
    hotelsFilter: store.getIn(['customer', 'filters', 'hotels']) || Map(),
    langCode: langCodeCorrector(langCode),
    city: city || Map(),
    country: country || Map(),
    googleApiKey: store.getIn(['customer', 'google_api_key'], ''),
    currencies: store.getIn(['customer', 'currencies']),
    currentCurrencyCode: store.getIn(['customer', 'current_currency']) || undefined,
    customerCountry: store.getIn(['customer', 'country', 'code'], 'ES'),
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  showPopover,
  PropertyManager([
    'availStringParams',
    'hotelsIds',
    'cities',
    'hotels',
    'avail',
    'hotelsFilter',
    'showToolTip',
    'hover',
    'hotelToShow',
    'onNextClick',
    'city',
    'country',
    'langCode',
    'closeByFamily',
    'googleApiKey',
    'currencies',
    'currentCurrencyCode',
    'customerCountry'
  ]),
  withThemeJSS({ styleFile, link: true })
)(GoogleMap);
